// Components
import { Box, Button, ButtonGroup, Flex, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Icon, Lottie, Modal, Show } from "components"
import { Enums } from "config"
import { API } from "config"
import { useOrder } from "hooks"
import { useState } from "react"
import { Authenticate } from "screens"

export default function Withdraw({ data }){

    const order = useOrder(data?.id)
    const confirm = useDisclosure()

    return(
    <>
    <Flex justifyContent="center" alignItems="center">
        <Box mr={4}><Lottie animation="withdraw" options={{ loop: true }} style={{ width: 200 }} /></Box>
        <Box maxW="40%">
            <Text fontSize="lg" fontWeight="bold" children="Aguardando retirada..." />
            <Text color="GrayText">
                A remessa encontra-se disponível para retirada na expedição pelo cliente.
            </Text>

            <Button mt={6} leftIcon={<Icon name="check" />} children="Confirmar retirada e concluir" isDisabled={order.isFetching} colorScheme="green" onClick={confirm.onOpen} />
        </Box>
    </Flex>

    <Confirm {...confirm} data={order.data} onSuccess={order.refetch} />
    </>
    )
}

const Confirm = ({ data, onSuccess = () => {}, ...props }) => {

    const toast = useToast()
    const auth = useDisclosure()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/orders/${data.id}/done`)
            toast({ title: 'O pedido foi finalizado', status: 'success'})
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível finalizar o pedido.', description: err?.response?.data?.message, status: 'warning'})
        }

        setLoading(false)
    }

    return(
    <>
    <Modal title={`Confirmar entrega do pedido #${data?.cod}`} {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">
                    Você está prestes a confirmar a retirada do pedido pelo cliente e finalizar a ordem de serviço. Atente-se aos efeitos colaterais pois esta ação é irreversível.
                </Text>

               <Show visible={data.type === Enums.OrderType.DISTRIBUTOR}>
                    <Alert title="Pedido de núcleo de distribuição" status="warning">Ao finalizar pedidos de núcleo, os itens adquiridos serão adicionados ao estoque do núcleo.</Alert>
               </Show>
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button leftIcon={<Icon name="done" />} children="Confirmar retirada e finalizar" colorScheme="orange" isLoading={loading} onClick={auth.onOpen} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}